import { render, staticRenderFns } from "./ManagerListChats.vue?vue&type=template&id=21950376&scoped=true&"
import script from "./ManagerListChats.vue?vue&type=script&lang=js&"
export * from "./ManagerListChats.vue?vue&type=script&lang=js&"
import style0 from "./ManagerListChats.vue?vue&type=style&index=0&id=21950376&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21950376",
  null
  
)

export default component.exports